import _ from 'lodash'
import { CellDefaultWidth, SelectionMode } from './config'
import DataGridCell from './DataGridCell'

import Checkbox from '../checkbox'
import { Radio } from '../radio'
import Tooltip from '../tooltip'

export default {
  name: 'KDataGridColumn',
  mixins: [],
  props: {
    field: {
      type: String, // 对应 dataGrid 中 data 项的 key
      default: '',
    },
    title: {
      type: String, // 头部显示 label
      default: '',
    },
    width: {
      type: Number, // 列宽
      default: CellDefaultWidth,
    },
    align: {
      // 内容对齐方式：left center right
      type: String,
      default: '',
    },
    fixedWidth: {
      // 列宽固定不变：正常列宽会根据容器宽度动态调整，为 true 时不参与调整
      type: Boolean,
      default: false,
    },
    fixed: {
      // 列固定，当列总宽度超过容器宽度时，固定的列不会滚动
      type: String,
      default: '',
    },
    checkbox: {
      // 是否是选择列，配合 selectionMode 使用
      type: Boolean,
      default: false,
    },
    renderContent: {
      type: Function,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    context() {
      let parent = this.$parent
      while (parent && parent.$options && parent.$options.name !== 'KDataGrid') {
        parent = parent.$parent
      }
      return parent
    },
    store() {
      return this.context.store
    },
    layout() {
      return this.context.layout
    },
    data() {
      return this.store.data
    },
    realWidth() {
      if (this.fixedWidth) {
        return this.width
      }

      const flexibleGap = this.layout.flexibleGap
      if (flexibleGap > 0) {
        const totalFlexibleWidth = this.layout.totalFlexibleWidth
        const ratio = this.width / totalFlexibleWidth
        const additionalWidth = flexibleGap * ratio
        return this.width + additionalWidth
      }

      return this.width
    },
    multiple() {
      return this.store.selectionMode === SelectionMode.Multiple
    },
    innerSelection() {
      return this.store.innerSelection
    },
    innerSelectableData() {
      return this.store.innerSelectableData
    },
  },
  created() {
  },
  mounted() {
    this.store.apiAddColumn(this)
  },
  destroyed() {
    this.store.apiRemoveColumn(this)
  },
  methods: {
    handleCellHover(cell) {
      this.store.hoverCell = cell
    },
    handleCheckboxClick(e, row) {
      e.stopPropagation()
      this.store.apiHandleRowClick(row, true)
    },
    handleHeaderCheckboxClick(e) {
      e.stopPropagation()
      this.store.apiHandleHeaderCheckboxClick()
    },
    getColData() {
      const style = {
        width: this.realWidth + 'px',
      }

      const css = {
        'km-data-grid__col': true,
      }

      const attrs = {}
      // if (this.field) {
      //   attrs['field-' + this.field] = ''
      // }

      const events = {}

      const data = {
        style: style,
        class: css,
        attrs: attrs,
        on: events,
      }

      return data
    },
    renderCheckboxHeaderCell() {
      if (!this.visible) {
        return
      }

      let selectionTrigger = null

      const custom = !_.isNil(this.$scopedSlots.title)
      if (custom) {
        selectionTrigger = this.$scopedSlots.title({
          store: this.store,
        })
      } else if (this.innerSelectableData.length) {
        if (this.multiple) {
          const checked = this.innerSelection.length === this.innerSelectableData.length
          const indeterminate = this.innerSelection.length > 0 && !checked
          const tooltip = checked
            ? '点击全不选'
            : `点击全选` +
            (this.innerSelection.length
              ? `，已选 ${this.innerSelection.length} / ${this.innerSelectableData.length}`
              : '')

          selectionTrigger = (
            <Tooltip
              content={tooltip}
              adjustOnChange
            >
              <Checkbox
                small={true}
                checked={checked}
                indeterminate={indeterminate}
                ripple={false}
                anim={false}
                style={{ height: '17px' }}
                nativeOnClick={(e) => {
                  this.handleHeaderCheckboxClick(e)
                }}
              />
            </Tooltip>
          )
        }
      } else {
        selectionTrigger = <div style={{ height: '17px' }} />
      }

      return (
        <div style={{ minHeight: '30px' }} {...this.getColData()}>
          <DataGridCell
            inHeader={true}
            align={this.align}
          >
            {selectionTrigger}
          </DataGridCell>
        </div>
      )
    },
    renderCheckboxCell(rowData, { rowIndex, colIndex, rowInstance }) {
      if (!this.visible) {
        return
      }

      let selectionTrigger = null

      const selectable = _.includes(this.innerSelectableData, rowData)
      const custom = !_.isNil(this.$scopedSlots.default)

      if (selectable) {
        const checked = _.includes(this.innerSelection, rowData)
        if (this.multiple) {
          selectionTrigger = (
            <Checkbox
              small={true}
              checked={checked}
              ripple={false}
              anim={false}
              style={{ height: '17px' }}
              nativeOnClick={(e) => {
                this.handleCheckboxClick(e, rowInstance)
              }}
            />
          )
        } else {
          selectionTrigger = (
            <Radio
              small={true}
              checked={checked}
              style={{ height: '17px' }}
              nativeOnClick={(e) => {
                this.handleCheckboxClick(e, rowInstance)
              }}
            />
          )
        }
      } else if (custom) {
        selectionTrigger = this.$scopedSlots.default({
          row: rowData,
          $index: rowIndex,
          $colIndex: colIndex,
          store: this.store,
        })
      } else {
        selectionTrigger = <div style={{ height: '17px' }} />
      }

      return (
        <div
          key={colIndex}
          onClick={(e) => this.handleCheckboxClick(e, rowInstance)}
          {...this.getColData()}
        >
          <DataGridCell
            rowIndex={rowIndex}
            colIndex={colIndex}
            hoverCell={this.store.hoverCell}
            onHoverCell={this.handleCellHover}
            align={this.align}
            custom={custom}
          >
            {selectionTrigger}
          </DataGridCell>
        </div>
      )
    },
    apiRenderHeaderCell() {
      if (!this.visible) {
        return
      }

      if (this.checkbox) {
        return this.renderCheckboxHeaderCell()
      }

      const custom = !_.isNil(this.$scopedSlots.title)
      const content = custom
        ? this.$scopedSlots.title({
          store: this.store,
        })
        : this.title || ''

      return (
        <div {...this.getColData()}>
          <DataGridCell
            custom={custom}
            inHeader={true}
            align={this.align}
          >
            {content}
          </DataGridCell>
        </div>
      )
    },
    apiRenderRowFooterCell() {
      if (!this.visible) {
        return
      }

      const custom = !_.isNil(this.$scopedSlots.rowFooter)
      const content = custom
        ? this.$scopedSlots.rowFooter({
          store: this.store,
        })
        : ''
      return (
        <div {...this.getColData()}>
          <DataGridCell
            custom={custom}
            align={this.align}
          >
            {content}
          </DataGridCell>
        </div>
      )
    },
    apiRenderCell(rowData, { rowIndex, colIndex, rowInstance }) {
      if (!this.visible) {
        return
      }

      if (this.checkbox) {
        return this.renderCheckboxCell(rowData, { rowIndex, colIndex, rowInstance })
      }

      let content = null
      let custom = false
      const params = {
        row: rowData,
        $index: rowIndex,
        $colIndex: colIndex,
        store: this.store,
      }
      if (this.renderContent && _.isFunction(this.renderContent)) {
        custom = true
        content = this.renderContent(params)
      } else {
        custom = !_.isNil(this.$scopedSlots.default)
        content = custom
          ? this.$scopedSlots.default(params)
          : rowData[this.field] || ''
      }

      return (
        <div key={colIndex} {...this.getColData()}>
          <DataGridCell
            rowIndex={rowIndex}
            colIndex={colIndex}
            hoverCell={this.store.hoverCell}
            onHoverCell={this.handleCellHover}
            align={this.align}
            custom={custom}
          >
            {content}
          </DataGridCell>
        </div>
      )
    },
  },
  render() {
  },
}
